<template>
  <div class="has-content">
    <f7-link @click="contactExpanded = !contactExpanded">
      <div class="contact-item-title">
        <div>联系信息</div>
        <div>
          <f7-icon :fa="contactExpanded ? 'angle-up' : 'angle-right'"></f7-icon>
        </div>
      </div>
    </f7-link>
    <div class="project" v-show="contactExpanded">
      <div class="project-item">
        <div class="project-item-label">
          联系人
        </div>
        <div class="project-item-text">
          <span class="project-item-text-wrap">
            {{ project.projectPublishVO.contactpeopleName }}
          </span>
        </div>
      </div>
      <div class="project-item">
        <div class="project-item-label">
          联系电话
        </div>
        <div class="project-item-text">
          <span class="project-item-text-wrap">
            {{ project.projectPublishVO.contactpeoplePhone }}
          </span>
        </div>
      </div>
      <div class="project-item">
        <div class="project-item-label">
          截止日期
        </div>
        <div class="project-item-text">
          <span class="project-item-text-wrap">
            {{ project.projectPublishVO.validityDate | formatDateValue }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dateFormat } from '@/util/dateUtils';

export default {
  props: ['project'],
  data() {
    return {
      contactExpanded: true,
    };
  },
  filters: {
    formatDateValue: value => dateFormat(value),
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .contact-item-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0.5rem;
    background-color: $panel-bg-color;
    font-size: 1rem;
  }

  .project {
    padding: 0rem 0.5rem;
  }

  .project-item {
    font-size: 1rem;
    display: flex;
    align-items: flex-start;
    width: 100%;
    padding: 0.5rem 0rem;
    border-bottom: 0.05rem solid $border-color;
  }

  .project-item:last-child {
    border-bottom: none;
  }

  .project-item-label {
    white-space: nowrap;
    color: $font-color;
    padding-right: 0.5rem;
  }

  .project-item-text {
    text-align: right;
    flex: auto;
    color: $second-font-color;
  }

  .project-item-text-wrap {
    text-align: left;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/ContactView.vue